import styled from 'styled-components';

export const Container = styled.div``;

export const MenuItems = styled.ul`
  margin: 0;
  padding: 0;
`;

export const MenuItem = styled.li`
  list-style: none;
  width: 100%;
  padding: 0.75rem 1rem;
  cursor: pointer;
  white-space: nowrap;
  font-weight: normal;
  font-size: 0.9rem;

  &:hover {
    background-color: ${({ theme }) => theme.colors.lightestGray};
  }
`;

export const PopoverCard = styled.div`
  min-width: 8rem;
  background-color: ${({ theme }) => theme.colors.white};
  box-shadow: 0 2px 10px 0 rgba(0, 0, 0, 0.16);

  &::after {
    content: '';
    position: absolute;
    width: 0;
    height: 0;
    margin-left: -1em;
    margin-top: -10px;
    left: 30px;
    top: 0;
    box-sizing: border-box;
    border: 10px solid black;
    border-color: transparent transparent #fff #fff;
    transform-origin: 50% 50%;
    transform: rotate(135deg);
    box-shadow: -2px 2px 2px 0 rgb(0 0 0 / 0.04);
  }
`;
